import React from 'react'
import PulseLoader from "react-spinners/PulseLoader";

const SubmitButton = ({children,loading,...rest}) => {
    return (
        <button className='w-full bg-[#0E86D4] text-white font-medium py-2.5 text-md rounded' type="submit" {...rest}> 
            {loading ? <PulseLoader color="white" /> : children}
        </button>
    )
}

export default SubmitButton
